import { io, Socket } from 'socket.io-client';

// Socket.IO runs on the root URL, not under /api
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';
const SOCKET_URL = API_URL.replace('/api', ''); // Remove /api suffix for Socket.IO

let socket: Socket | null = null;

export const initializeSocket = () => {
  if (!socket) {
    console.log('🔌 Initializing socket connection to:', SOCKET_URL);
    socket = io(SOCKET_URL, {
      transports: ['websocket', 'polling'],
      withCredentials: true,
      reconnection: true,
      reconnectionDelay: 1000,
      reconnectionAttempts: 5,
      timeout: 10000
    });

    socket.on('connect', () => {
      console.log('✅ Socket connected:', socket?.id);
    });

    socket.on('disconnect', () => {
      console.log('❌ Socket disconnected');
    });

    socket.on('connect_error', (error) => {
      console.error('❌ Socket connection error:', error);
      console.error('   Error type:', error.constructor.name);
      console.error('   Error message:', error.message);
    });
  }

  return socket;
};

export const getSocket = (): Socket => {
  if (!socket) {
    return initializeSocket();
  }
  return socket;
};

export const disconnectSocket = () => {
  if (socket) {
    socket.disconnect();
    socket = null;
  }
};

// Join specific auction room
export const joinAuction = (auctionId: string) => {
  const socket = getSocket();
  socket.emit('join-auction', auctionId);
};

// Leave specific auction room
export const leaveAuction = (auctionId: string) => {
  const socket = getSocket();
  socket.emit('leave-auction', auctionId);
};

// Join auctions list room
export const joinAuctionsList = () => {
  const socket = getSocket();
  socket.emit('join-auctions-list');
};

// Leave auctions list room
export const leaveAuctionsList = () => {
  const socket = getSocket();
  socket.emit('leave-auctions-list');
};

// Listen for auction updates
export const onAuctionUpdate = (callback: (data: any) => void) => {
  const socket = getSocket();
  socket.on('auction-updated', callback);
};

// Listen for auctions list updates
export const onAuctionsListUpdate = (callback: () => void) => {
  const socket = getSocket();
  socket.on('auctions-list-updated', callback);
};

// Remove auction update listener
export const offAuctionUpdate = (callback: (data: any) => void) => {
  const socket = getSocket();
  socket.off('auction-updated', callback);
};

// Remove auctions list update listener
export const offAuctionsListUpdate = (callback: () => void) => {
  const socket = getSocket();
  socket.off('auctions-list-updated', callback);
};
